import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TwcModule, TwcTopconOneModule } from '@topcon/twc-angular';

import { BrandBarComponent } from './brand-bar.component';

@NgModule({
    declarations: [BrandBarComponent],
    imports: [
        CommonModule,
        TwcModule,
        RouterModule,
        // Real topconOne configuration loaded in app.module.ts with TwcTopconOneCredentials provider.
        TwcTopconOneModule.forRoot({
            auth_backend: '',
            client_id: '',
            apiVersion: '',
            host: '',
            scope: '',
            state: '',
        }),
    ],
    exports: [BrandBarComponent],
})
export class BrandBarModule {}
